import React, { useState, useEffect, useRef } from 'react';
import { Editor } from "@tinymce/tinymce-react";
import { environment } from '../../../config.env';

const ENDPOINT_DOMAIN = environment.endpoint_domain || '';

function TinyMCE({
  value = '',
  setValue = () => { },
}) {
  //console.log(value)
  const [editorValue, setEditorValue] = useState(value);
  const editorRef = useRef(null);

  // Sync value จาก props เมื่อมีการเปลี่ยนแปลง
  useEffect(() => {
    setEditorValue(value);
  }, [value]);

  // เมื่อ editorValue เปลี่ยนแปลง, ส่งค่าไปยัง setValue
  useEffect(() => {
    if (editorValue !== value) {
      setValue(editorValue);
    }
  }, [editorValue, setValue, value]);

  // ฟังก์ชันเพื่อจัดการการเปลี่ยนแปลงของ Editor
  const handleEditorChange = (content, editor) => {
    setEditorValue(content);
  };

  const filePickerCallback = (callback, value, meta) => {
    // ใช้ `filePickerCallback` เพื่อจัดการการเลือกไฟล์ และการอัปโหลด
    //console.log(meta)
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    if (meta.filetype === 'file') {
      input.setAttribute('accept', 'pdf/*');
    } if (meta.filetype === 'image') {
      input.setAttribute('accept', 'image/*');
    }
    input.click();

    // console.log(input)

    input.onchange = () => {
      const file = input.files[0];
      const formData = new FormData();
      formData.append('image', file);

      // ส่งภาพไปยังเซิร์ฟเวอร์
      fetch(ENDPOINT_DOMAIN + '/api/v1/admin/content/upload-image-content', {
        method: 'POST',
        body: formData,
        headers: {
          'Authorization': localStorage.getItem('pg_access_token')
        }
      })
        .then(response => response.json())
        .then(data => {
          if (data.url) {
            // ส่ง URL ของภาพกลับไปยัง editor
            // callback(data.url);  // ต้องเรียกใช้ callback เพื่อส่ง URL กลับ
            const imageUrl = data.url;

            fetch(imageUrl)
              .then(res => res.blob())
              .then(blob => {
                const reader = new FileReader();
                reader.onloadend = function () {
                  const base64data = reader.result;
                  callback(base64data, { title: file.name });
                };
                reader.readAsDataURL(blob);
              })
              .catch(err => {
                console.error("❌ Error fetching image from URL:", err);
                callback(imageUrl, { title: file.name });
              });
          }
        })
        .catch(error => {
          console.error('Error uploading image:', error);
        }).finally(() => {
                input.remove();
        });
    };
  };

  return (
    <>
      <Editor
        onEditorChange={handleEditorChange}  // ใช้ handleEditorChange
        tinymceScriptSrc="/tinymce/tinymce.min.js"  // ใส่ API Key ของคุณ
        onInit={(_evt, editor) => {
          editorRef.current = editor; // เก็บ ref ของ editor
        }}
        value={editorValue}  // ใช้ editorValue แทน initialValue
        init={{
          height: 500,
          menubar: false,
          plugins: [
            "advlist",
            "autolink",
            "lists",
            "link",
            "charmap",
            "preview",
            "anchor",
            "searchreplace",
            "visualblocks",
            "code",
            "fullscreen",
            "insertdatetime",
            "media",
            "table",
            "image",
            "code",
            "help",
            "wordcount",
          ],
          toolbar:
            "undo redo | blocks | " +
            "bold italic forecolor | fontsize | alignleft aligncenter " +
            "alignright alignjustify | bullist numlist outdent indent | " +
            "link image media|" +
            "table tabledelete | " +
            "removeformat | help",

          //images_upload_url: ENDPOINT_DOMAIN+'/api/v1/admin/content/upload-image-content', // API endpoint สำหรับอัปโหลด
          automatic_uploads: true, // อัปโหลดอัตโนมัติ
          file_picker_types: 'file image', // ใช้เฉพาะการเลือกไฟล์รูปภาพ
          file_picker_callback: filePickerCallback, // ใช้ `file_picker_callback` สำหรับการอัปโหลด

          relative_urls: false,
          remove_script_host: false,
          convert_urls: true,

          font_size_formats: "12px 14px 16px 18px 20px 22px 24px 30px 36px",

          media_poster: false,
          media_alt_source: false
        }}
      />
    </>
  );
}

export default TinyMCE;
